import React from "react";

/**
 * 2×3 grid-of-dots "more options" icon (matches Figma card header handle).
 *
 * @param {string} [color="#98A2B3"]
 * @param {number} [dotRadius=1.4]
 * @param {number} [size=14]        Width AND height of the rendered SVG in px
 */
const DotsMenu = ({ color = "#98A2B3", dotRadius = 1.4, size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    {/* column 1 */}
    <circle cx="4" cy="2.5" r={dotRadius} fill={color} />
    <circle cx="4" cy="7" r={dotRadius} fill={color} />
    <circle cx="4" cy="11.5" r={dotRadius} fill={color} />
    {/* column 2 */}
    <circle cx="10" cy="2.5" r={dotRadius} fill={color} />
    <circle cx="10" cy="7" r={dotRadius} fill={color} />
    <circle cx="10" cy="11.5" r={dotRadius} fill={color} />
  </svg>
);

export default DotsMenu;
